import { useMemo } from 'react';
import { useUserData } from '../context/UserDataContext';
import type { PersonIdentifier } from '../types/api';

export const useDashboardData = () => {
  const { personData, storeData, loading } = useUserData();

  const person = personData?.PersonResponse?.PersonResponse;
  const offers = personData?.OffersResponse?.GetOffersResponses || [];
  const store = Array.isArray(storeData?.EntityResponses) 
    ? storeData?.EntityResponses[0] 
    : storeData?.EntityResponses;

  const cardIdentifier = useMemo(() => {
    const now = new Date();
    const allIdentifiers = personData?.PersonResponse?.IdentifierResponse || [];
    
    const activeIdentifiers = allIdentifiers
      .filter((id: PersonIdentifier) => {
        if (id.identifierType !== 1) return false;
        if (id.desactivationDate && new Date(id.desactivationDate) <= now) return false;
        if (id.activationDate && new Date(id.activationDate) > now) return false;
        return true;
      })
      .sort((a: PersonIdentifier, b: PersonIdentifier) => {
        const dateA = a.activationDate ? new Date(a.activationDate).getTime() : 0;
        const dateB = b.activationDate ? new Date(b.activationDate).getTime() : 0;
        return dateB - dateA;
      });
    
    return activeIdentifiers[0]?.identifierValue || '4007007007007';
  }, [personData]);

  const totalPoints = useMemo(() => {
    const accounts = personData?.AccountsResponse?.AccountResponse || [];
    return accounts.reduce((total, account) => total + (account.value || 0), 0);
  }, [personData]);

  const totalDiamonds = useMemo(() => Math.floor(Math.random() * 100) + 1, []);

  return {
    person,
    offers,
    store,
    cardIdentifier,
    totalPoints,
    totalDiamonds,
    loading
  };
};
